import { render, staticRenderFns } from "./SpSubNav.vue?vue&type=template&id=5db5cd44&"
import script from "./SpSubNav.vue?vue&type=script&lang=js&"
export * from "./SpSubNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports